import { filtersClearButton } from "../../utils/devextreme_utils";

const COLUMN_DEFAULTS = {
  visible: false,
  allowHeaderFiltering: false,
};

/**
 * @param {Object} [options = {}]
 * @param {Object} [options.columnOverrides = {}]
 * @param {Object} [options.columnDefaults = COLUMN_DEFAULTS]
 *
 * @returns {import("../datagrid").Plugin}
 */
export function columnsPlugin(options = {}) {
  return ($container) => {
    const rawColumns = JSON.parse($container.getAttribute("data-columns"));
    const columns = applyColumnOverrides(rawColumns, options.columnOverrides ?? {});

    return {
      id: "columns",
      options: { columns: applyDefaults(columns, options.columnDefaults ?? COLUMN_DEFAULTS) },
    };
  };
}

function applyColumnOverrides(columns, columnOverrides) {
  let unusedColumnOverrides = { ...columnOverrides };

  const overridenColumns = columns.map((column) => {
    const dataField = column["dataField"];
    const override = unusedColumnOverrides[dataField];
    if (!override) return column;

    delete unusedColumnOverrides[dataField];

    if (hasSubColumns(override)) {
      return {
        ...column,
        ...override,
        columns: applyColumnOverrides(column.columns, override.columns),
      };
    } else {
      return {
        ...column,
        ...override,
      };
    }
  });

  if (Object.keys(unusedColumnOverrides).length != 0) {
    const overridenCols = Object.keys(columnOverrides);
    const nonOverridenColumns = columns.filter((column) => !overridenCols.includes(column["dataField"]));
    console.warn("Some column overrides were not applied because no matching columns were found: ", unusedColumnOverrides);
    console.debug("List of non-overriden columns: ", nonOverridenColumns);
  }

  return overridenColumns;
}

function applyDefaults(columns, columnDefaults) {
  const columnsWithDefaults = columns.map((column) => {
    const columns = hasSubColumns(column) ? applyDefaults(column.columns, columnDefaults) : undefined;

    return {
      ...columnDefaults,
      ...column,
      columns,
    };
  });

  return filtersClearButton(columnsWithDefaults);
}

function hasSubColumns(column) {
  return Object.hasOwn(column, "columns");
}
